export default "__VITE_ASSET__DuuwoEl1__"